import React, { useState, useMemo, useEffect } from "react";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import { ReactComponent as Trash } from "../../assets/analyse/Trash.svg";
import { ReactComponent as Plus } from "../../assets/analyse/Plus.svg";

// REDUX
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { uploadFiles } from "../../redux/actions/analysisActions";

// utils
import MainButton from "../../commonComponents/MainButton";

const UploadDocuments = ({ setShowUploadPanel, step_index }) => {
  // REDUX DATA

  // REDUX ACTIONS
  const dispatch = useDispatch();
  const uploadFiles_rd = (item) => dispatch(uploadFiles(item));

  const [fileList, setFileList] = useState();
  const files = fileList ? [...fileList] : [];

  const handleFilesChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFileList(e.target.files);
    }
  };

  const handleUploadClick = async (event) => {
    // event.preventDefault();
    if (!fileList) {
      return;
    }

    //read data from the blob objects(file)
    var items = [];

    const fileToDataURL = (file) => {
      return new Promise(function (resolve, reject) {
        let fr = new FileReader();

        fr.onload = function () {
          resolve(fr.result);
        };

        fr.onerror = function () {
          reject(fr);
        };

        // fr.readAsText(file);
        fr.readAsDataURL(file);
        // console.log("reader.result", fr.result);
      });
    };

    let readers = [];

    // Store promises in array
    for (let i = 0; i < files.length; i++) {
      readers.push(fileToDataURL(files[i]));
    }

    // Trigger Promises
    await Promise.all(readers).then((values) => {
      // Values will be an array that contains an item
      // with the text of every selected file
      // ["File1 Content", "File2 Content" ... "FileN Content"]
      values.map((x) => {
        items.push({
          base64ImageString: x,
          type: x.split(";")[0].split(":")[1],
        });
      });
    });

    await uploadFiles_rd({items : items, step_index: step_index});
  };

  return (
    <>
      <div className="ml-[30px] mr-[30px]">
        <div className="h-[70px] flex items-center justify-start font-Poppins-SemiBold text-sm">{"À partir de vos documents"}</div>

        <div className="flex items-center justify-center w-full">
          <label
            htmlFor="dropzone-file"
            className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
          >
            <div className="flex flex-col items-center justify-center pt-5 pb-6">
              <svg aria-hidden="true" className="w-10 h-10 mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
              </svg>
              <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                <span className="font-semibold">Cliquer pour importer</span> où faîtes glisser un fichier
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400">PDF, PNG, JPEG or JPG (MAX. 800x400px)</p>
            </div>

            {/* <form onSubmit={handleUploadClick}> */}
            <input onChange={handleFilesChange} id="dropzone-file" type="file" name="files" className="hidden" multiple accept=".pdf, .png, .jpg, .jpeg" />
            {/* </form> */}
            {files.length > 0 && (
              <p className="mb-2 text-lg text-gray-500 dark:text-gray-400">
                <span className="font-semibold">{files.length + " fichiers"}</span> importés.
              </p>
            )}
          </label>
        </div>
      </div>

      <div className="flex items-center w-[200px] justify-center mt-8 h-[40px] ml-[400px]">
        <MainButton disabled={files.length > 0} title={"Analyser"} callback={handleUploadClick} />
      </div>
    </>
  );
};

export default UploadDocuments;
